import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=d08a1700&scoped=true&"
import script from "./Circles.vue?vue&type=script&lang=js&"
export * from "./Circles.vue?vue&type=script&lang=js&"
import style0 from "./Circles.vue?vue&type=style&index=0&id=d08a1700&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08a1700",
  null
  
)

export default component.exports